<img
	*ngIf="!imgLoaded"
	[src]="placeholderUrl"
	[attr.width]="width"
	[attr.height]="height"
	[ngClass]="extraClass"
	class="placeholder fade-in"
/>
<img
	[hidden]="!imgLoaded"
	[src]="imageUrl"
	[alt]="alt"
	title="{{alt}}"
	[attr.width]="width"
	[attr.height]="height"
	(load)="loadComplete()"
	[ngClass]="extraClass"
	class="fade-in2"
/>
